import type { Attachment } from '@medplum/fhirtypes'
import { Button } from '@seen/ui'
import { IconUpload } from '@tabler/icons-react'
import type { DragEvent, JSX, MouseEvent, ReactNode } from 'react'
import { CustomAttachmentButton } from '#src/components/button/CustomAttachmentButton.tsx'

interface UploadDocumentButtonProps {
  children?: (props: {
    disabled?: boolean
    onClick(e: MouseEvent): void
    onDrop(e: DragEvent): void
    onDragOver(e: DragEvent): void
  }) => ReactNode
  onUpload?: (attachments: Attachment[]) => void
}

export function UploadDocumentButton({
  children,
  onUpload,
}: UploadDocumentButtonProps): JSX.Element {
  const handleUpload = (attachments: Attachment[]): void => {
    onUpload?.(attachments)
  }

  const defaultButton = (props: {
    disabled?: boolean
    onClick(e: MouseEvent): void
    onDrop(e: DragEvent): void
    onDragOver(e: DragEvent): void
  }): ReactNode => (
    <Button {...props} variant="outline" className="flex items-center gap-2">
      <IconUpload size={16} />
      Add files
    </Button>
  )

  return (
    <CustomAttachmentButton
      onUpload={handleUpload}
      onUploadError={(error) => console.error(error)}
    >
      {(props) => (children ? children(props) : defaultButton(props))}
    </CustomAttachmentButton>
  )
}
